import React from "react";

import { ButtonStandard, Text } from "@performyard/py-components";

import ContentModal from "../../../../../components/Modal/Templates/ContentModal";

type DisconnectionModalProps = {
	isOpen: boolean;
	title: string;
	bodyText: string;
	isDisconnecting: boolean;
	handleConfirmDisconnect: () => void;
	handleCancelDisconnect: () => void;
};

/** Generic disconnect-confirmation modal for any meetings integration. */
export const DisconnectionModal = ({
	isOpen,
	title,
	bodyText,
	isDisconnecting,
	handleConfirmDisconnect,
	handleCancelDisconnect,
}: DisconnectionModalProps): React.ReactElement => {
	return (
		<ContentModal
			isOpen={isOpen}
			handleClose={handleCancelDisconnect}
			size="large"
			buttons={[
				<ButtonStandard
					key="cancel"
					variant="outline"
					color="neutral"
					onClick={handleCancelDisconnect}
					size="large"
					disabled={isDisconnecting}
					dangerouslySetClassName="w-auto min-w-[90px]"
				>
					Cancel
				</ButtonStandard>,
				<ButtonStandard
					key="disconnect"
					color="red"
					onClick={handleConfirmDisconnect}
					size="large"
					disabled={isDisconnecting}
					dangerouslySetClassName="w-auto min-w-[90px]"
				>
					Yes, Disconnect
				</ButtonStandard>,
			]}
		>
			<div className="flex flex-col text-center">
				<Text weight="semi-bold" size="sub-heading">
					{title}
				</Text>
				<Text weight="regular" size="paragraph-3">
					{bodyText}
				</Text>
			</div>
		</ContentModal>
	);
};
